import React from "react";
import { formatDate } from "../../../helpers/helpers";
import jsonData from "./Post03.json";
import json_navbar from "../../UI/Navbar/Navbar.json";

const BlogPost = ({ lang }) => {
  return (
    <div className="postContainer post-container-center">
      <div className="postHeader">
        <h1 className="postTitle">{jsonData.title[lang]}</h1>
        <span className="postedBy">{formatDate(lang, "2020-12-19")}</span>
      </div>
      <div className="postText postText-center">
        <p className="postText">{jsonData.text1[lang]}</p>
        <p className="postText">{jsonData.text2[lang]}</p>
        <p className="postText">
          {jsonData.text3[lang]} <a href="/Discography">{json_navbar.discography[lang]}</a>
          {jsonData.text4[lang]}
        </p>
      </div>
    </div>
  );
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/Home/post03/Post03.jsx